module.exports = __webpack_public_path__ + "img/cavelogo.5e9942cc.jpg";